var ref = require("prosemirror-model");
var Mark = ref.Mark;
var DOMParser = ref.DOMParser;
var ref$1 = require("prosemirror-state");
var Selection = ref$1.Selection;

var ref$2 = require("./dompos");
var DOMFromPos = ref$2.DOMFromPos;
var DOMFromPosFromEnd = ref$2.DOMFromPosFromEnd;

function readInputChange(view, oldState) {
  return readDOMChange(view, oldState, rangeAroundSelection(oldState.selection))
}
exports.readInputChange = readInputChange

function readCompositionChange(view, oldState, margin) {
  return readDOMChange(view, oldState, rangeAroundComposition(oldState.selection, margin))
}
exports.readCompositionChange = readCompositionChange

// Note that all referencing and parsing is done with the
// start-of-operation selection and document, since that's the one
// that the DOM represents. If any changes came in in the meantime,
// the modification is mapped over those before it is applied, in
// readDOMChange.

function parseBetween(view, oldState, from, to) {
  var ref = DOMFromPos(view, from, true);
  var parent = ref.node;
  var startOff = ref.offset;
  var ref$1 = DOMFromPosFromEnd(view, to);
  var parentRight = ref$1.node;
  var endOff = ref$1.offset;
  if (parent != parentRight) { return null }
  while (startOff) {
    var prev = parent.childNodes[startOff - 1]
    if (prev.nodeType != 1 || !prev.hasAttribute("pm-offset")) { --startOff }
    else { break }
  }
  while (endOff < parent.childNodes.length) {
    var next = parent.childNodes[endOff]
    if (next.nodeType != 1 || !next.hasAttribute("pm-offset")) { ++endOff }
    else { break }
  }
  var domSel = view.root.getSelection(), find = null
  if (domSel.anchorNode && view.content.contains(domSel.anchorNode)) {
    find = [{node: domSel.anchorNode, offset: domSel.anchorOffset}]
    if (!domSel.isCollapsed)
      { find.push({node: domSel.focusNode, offset: domSel.focusOffset}) }
  }
  var startDoc = oldState.doc
  var parser = view.someProp("domParser") || DOMParser.fromSchema(view.state.schema)
  var sel = null, doc = parser.parse(parent, {
    topNode: startDoc.resolve(from).parent.copy(),
    from: startOff,
    to: endOff,
    preserveWhitespace: true,
    editableContent: true,
    findPositions: find
  })
  if (find && find[0].pos != null) {
    var anchor = find[0].pos, head = find[1] && find[1].pos
    if (head == null) { head = anchor }
    sel = {anchor: anchor + from, head: head + from}
  }
  return {doc: doc, sel: sel}
}

function isAtEnd($pos, depth) {
  for (var i = depth || 0; i < $pos.depth; i++)
    { if ($pos.index(i) + 1 < $pos.node(i).childCount) { return false } }
  return $pos.parentOffset == $pos.parent.content.size
}
function isAtStart($pos, depth) {
  for (var i = depth || 0; i < $pos.depth; i++)
    { if ($pos.index(0) > 0) { return false } }
  return $pos.parentOffset == 0
}

function rangeAroundSelection(selection) {
  var $from = selection.$from;
  var $to = selection.$to;
  // When the selection is entirely inside a text block, use
  // rangeAroundComposition to get a narrow range.
  if ($from.sameParent($to) && $from.parent.isTextblock && $from.parentOffset && $to.parentOffset < $to.parent.content.size)
    { return rangeAroundComposition(selection, 0) }

  for (var depth = 0;; depth++) {
    var fromStart = isAtStart($from, depth + 1), toEnd = isAtEnd($to, depth + 1)
    if (fromStart || toEnd || $from.index(depth) != $to.index(depth) || $to.node(depth).isTextblock) {
      var from = $from.before(depth + 1), to = $to.after(depth + 1)
      if (fromStart && $from.index(depth) > 0)
        { from -= $from.node(depth).child($from.index(depth) - 1).nodeSize }
      if (toEnd && $to.index(depth) + 1 < $to.node(depth).childCount)
        { to += $to.node(depth).child($to.index(depth) + 1).nodeSize }
      return {from: from, to: to}
    }
  }
}

function rangeAroundComposition(selection, margin) {
  var $from = selection.$from;
  var $to = selection.$to;
  if (!$from.sameParent($to)) { return rangeAroundSelection(selection) }
  var startOff = Math.max(0, $from.parentOffset - margin)
  var size = $from.parent.content.size
  var endOff = Math.min(size, $to.parentOffset + margin)

  if (startOff > 0)
    { startOff = $from.parent.childBefore(startOff).offset }
  if (endOff < size) {
    var after = $from.parent.childAfter(endOff)
    endOff = after.offset + after.node.nodeSize
  }
  var nodeStart = $from.start()
  return {from: nodeStart + startOff, to: nodeStart + endOff}
}

function enterEvent() {
  var event = document.createEvent("Event")
  event.initEvent("keydown", true, true)
  event.keyCode = 13
  event.code = "Enter"
  return event
}

function readDOMChange(view, oldState, range) {
  var parseResult, doc = oldState.doc
  for (;;) {
    parseResult = parseBetween(view, oldState, range.from, range.to)
    if (parseResult) { break }
    var $from$1 = doc.resolve(range.from), $to$1 = doc.resolve(range.to)
    range = {from: $from$1.depth ? $from$1.before() : 0,
             to: $to$1.depth ? $to$1.after() : doc.content.size}
  }
  var parsed = parseResult.doc;
  var parsedSel = parseResult.sel;

  var compare = doc.slice(range.from, range.to)
  var change = findDiff(compare.content, parsed.content, range.from, oldState.selection.from)
  if (!change) { return false }

  // Mark nodes touched by this change as 'to be redrawn'
  view.dirty = {from: change.start, to: change.endA}

  var $from = parsed.resolveNoCache(change.start - range.from)
  var $to = parsed.resolveNoCache(change.endB - range.from)
  var nextSel, text, event
  // If this looks like the effect of pressing Enter, just dispatch an
  // Enter key instead.
  if (!$from.sameParent($to) && $from.pos < parsed.content.size &&
      (nextSel = Selection.findFrom(parsed.resolve($from.pos + 1), 1, true)) &&
      nextSel.head == $to.pos &&
      (event = enterEvent()) &&
      view.someProp("handleKeyDown", function (f) { return f(view, event); }))
    { return }

  var from = change.start, to = change.endA
  // If there have been changes since this DOM update started, we must
  // map our start and end positions, as well as the new selection
  // positions, through them.
  var mapping = view.state.view.domChangeMapping
  if (mapping) {
    from = mapping.map(from)
    to = mapping.map(to)
    if (parsedSel) { parsedSel = {anchor: mapping.map(parsedSel.anchor),
                                head: mapping.map(parsedSel.head)} }
  }

  var tr = view.state.tr
  if ($from.sameParent($to) && $from.parent.isTextblock &&
      (text = uniformTextBetween(parsed, $from.pos, $to.pos)) != null) {
    if (view.someProp("handleTextInput", function (f) { return f(view, from, to, text); })) { return }
    tr.insertText(text, from, to)
  } else {
    tr.replace(from, to, parsed.slice(change.start - range.from, change.endB - range.from))
  }

  if (parsedSel)
    { tr.setSelection(Selection.between(tr.doc.resolve(parsedSel.anchor),
                                      tr.doc.resolve(parsedSel.head))) }
  view.props.onAction(tr.scrollAction())
}

function uniformTextBetween(node, from, to) {
  var result = "", valid = true, marks = null
  node.nodesBetween(from, to, function (node, pos) {
    if (!node.isInline && pos < from) { return }
    if (!node.isText) { return valid = false }
    if (!marks) { marks = node.marks }
    else if (!Mark.sameSet(marks, node.marks)) { valid = false }
    result += node.text.slice(Math.max(0, from - pos), to - pos)
  })
  return valid ? result : null
}

function findDiff(a, b, pos, preferedStart) {
  var start = a.findDiffStart(b, pos)
  if (!start) { return null }
  var ref = a.findDiffEnd(b, pos + a.size, pos + b.size);
  var endA = ref.a;
  var endB = ref.b;
  if (endA < start) {
    var move = preferedStart <= start && preferedStart >= endA ? start - preferedStart : 0
    start -= move
    endB = start + (endB - endA)
    endA = start
  } else if (endB < start) {
    var move$1 = preferedStart <= start && preferedStart >= endB ? start - preferedStart : 0
    start -= move$1
    endA = start + (endA - endB)
    endB = start
  }
  return {start: start, endA: endA, endB: endB}
}



//////////////////
// WEBPACK FOOTER
// ../~/prosemirror-view/dist/domchange.js
// module id = 850
// module chunks = 0